/**
 * Schermteksten in het Russisch.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const ru: Teksten = {
  kamerOphalen: "Подключение к комнате…",
  kamerWerktNiet: "Эта комната не работает",
  serverReageertNiet: "Сервер не отвечает",
  probeerOpnieuw: "Попробуй еще раз",
  vraagNieuweCode: "Попроси новый код у того, кто им поделился. Комната устаревает через несколько часов.",
  welkeTaalSprekJij: "На каком языке ты говоришь?",
  jouwStem: "Твой голос в переводе",
  man: "Мужской",
  vrouw: "Женский",
  pincode: "Пин-код",
  pincodeUitleg: "Его можно получить у того, кто поделился кодом.",
  gaDeKamerIn: "Войти в комнату",
  kiesEerstJeTaal: "Сначала выбери язык",
  microfoonAanvragen: "Запрос микрофона…",
  toestemmingUitleg: "Браузер запросит разрешение на доступ к микрофону. Без него можно будет только писать.",
  microfoonTestLink: "Сначала проверь микрофон",
  stemGaatMee: "В этой комнате собеседник также услышит твой настоящий голос, помимо перевода.",
  alleenChatMelding: "Этот разговор — только чат. Ты пишешь сообщения и читаешь перевод; ничего не зачитывается вслух.",
  verlooptOm: "Истекает в",
  nooitVasteKamer: "Никогда, постоянная комната",
  kamer: "Комната",
  tolkgesprek: "Синхронный перевод",
  juisteKamer: "Ты в нужной комнате. Скоро ты сможешь начать общение.",
  jij: "ты",
  deAnder: "собеседник",
  verbinden: "Соединение…",
  verbonden: "Подключено",
  verbindingKwijt: "Связь потеряна. Повторное подключение…",
  wachtenOpAnder: "Ты на месте. Ожидание, пока собеседник отсканирует QR-код.",
  allebeiInDeKamer: "Вы оба в комнате.",
  anderIsWeg: "Собеседник ушел",
  anderSpreekt: "Собеседник говорит…",
  jeKuntErNietIn: "Вход невозможен",
  overgenomenTitel: "Общение продолжено на другом устройстве",
  overgenomenUitleg: "Этот разговор только что открыли на другом устройстве. Продолжай общение там.",
  terug: "Назад",
  geluidStaatUit: "Звук выключен. Коснись экрана в любом месте.",
  tikHier: "нажми здесь",
  bewaardTot: 'Хранится до {tijd}',
  bewaardVast: "Постоянная комната. Сообщения хранятся 30 дней.",
  spreekIn: "Говори",
  luisteren: "Слушаю… нажми, чтобы остановить",
  uitschrijven: "Расшифровка…",
  tijdOmTeVerbeteren: "Время на исправление",
  altijdZelfVersturen: "Всегда проверять и отправлять вручную",
  jijVerstuurtZelf: "Отправка вручную",
  uit: "выкл",
  sec: "сек",
  vertalingMeteenAfspelen: "Сразу озвучивать перевод",
  typHierJeBericht: "Напиши сообщение…",
  stuur: "Отправить",
  geenOpnameMogelijk: "Этот браузер не поддерживает запись аудио. Но ты можешь писать.",
  verstaanAls: "Распознано как",
  tellerStaatStil: "таймер остановлен",
  versturen: "Отправить",
  wis: "Очистить",
  jijZei: "ты сказал(а)",
  vertaald: "перевод",
  duimOmhoog: "Всё верно",
  duimOmlaag: "Неверно",
  opnieuwProberenKnop: "Попробовать снова с лучшей моделью",
  opnieuwProberenBezig: "Перевожу заново…",
  duimTranscriptWoordenlijstUitnodiging: "Неправильно распознано? Добавь в словарь:",
  instellingenAanpassen: "Изменить настройки",
  geldtVoorJullieBeiden: "Применяется к обоим",
  alleenVoorJou: "Только для тебя",
  stuurMijnStemMee: "Передавать мой голос",
  verbeterSpelfouten: "Исправлять опечатки в моем тексте",
  verbeterSpelfoutenUit: "Если выключено, будет показано именно то, что было распознано, с ошибками.",
  alleenChat: "Только чат: без голоса, без микрофона",
  alleenChatUitleg: "Вы оба пишете. Показываются перевод и исходный текст; ничего не зачитывается вслух.",
  aangepastDoorDeAnder: "Собеседник изменил настройки.",
  foutSpraak: "Перевод готов, но озвучка не сработала.",
  foutSpraakQuota: "Лимит озвучки на сегодня исчерпан. Текст работает как обычно, голос вернется завтра.",
  foutBudgetKamer: "Этот разговор достиг своего лимита, поэтому перевод приостановлен. Создатель разговора может его увеличить — после этого всё сразу снова заработает.",
  foutBudgetMaand: "Месячный бюджет приложения исчерпан. Перевод снова заработает, когда администратор его изменит.",
  foutTaal: "Этот язык недоступен: вы оба будете говорить на одном языке.",
  origineel: "оригинал",
  vertalen: "Перевод…",
  vertalenMislukt: "Не удалось перевести.",
  opnieuwAfspelen: "Повторить перевод",
  hoorDeAnder: "Послушать оригинал речи собеседника",
  woordenlijst: "Словарь автозамен",
  woordenlijstUitleg: "Приложение постоянно путает имя или термин? Запиши здесь правильный вариант.",
  hijHoort: "слышится…",
  jijBedoelt: "имелось в виду…",
  ookVolgendeGesprekken: "И в следующих диалогах — иначе только в этом",
  voegToe: "Добавить",
  bezig: "Выполняется…",
  lijstNietGeladen: "Не удалось загрузить список.",
  toevoegenMislukt: "Не удалось добавить.",
  verwijderenMislukt: "Не удалось удалить.",
  overal: "везде",
  verwijder: "Удалить",
  overDitGesprek: "О диалоге",
  toon: "Стиль перевода",
  sfeer: "Атмосфера беседы",
  jouwPlek: "Твое место",
  hoeHetWerkt: "Сервер расшифровывает твою запись и переводит её за один раз. Твой голос передается собеседнику.",
  kleinereTekst: "Уменьшить текст",
  grotereTekst: "Увеличить текст",
  insprekenVerbergen: "Скрыть голосовой ввод",
  insprekenTonen: "Показать голосовой ввод",
  toetsenbordVerbergen: "Скрыть клавиатуру",
  toetsenbordTonen: "Показать клавиатуру",
  vormAutomatisch: "Автоматически",
  vormInformeel: "На «ты»",
  vormFormeel: "На «вы»",
  sfeerNeutraal: "Нейтральная",
  sfeerZakelijk: "Деловая",
  sfeerOfficieel: "Официальная",
  sfeerVriendschappelijk: "Дружеская",
  sfeerPartner: "Близкая",
  foutKamerVol: "Эта комната заполнена. В ней могут находиться только два человека.",
  plekBezetTitel: "Твоё место занято",
  plekBezetUitleg: "На твоей стороне этого разговора уже кто-то есть, на твоём языке. Обычно это ты сам: разговор ещё открыт на другом устройстве или в другой вкладке. Закрой его там и попробуй снова. Иногда место освобождается только через полторы минуты.",
  plekBezetWissel: "Это ты? Введи WISSEL, чтобы перенести разговор на это устройство. Другое устройство тогда закроется.",
  plekBezetKnop: "Перенести на это устройство",
  foutKamerVerlopen: "Срок действия этой комнаты истек или она закрыта.",
  foutKamerOnbekend: "Эта комната не существует.",
  foutPinNodig: "Для входа в эту комнату нужен пин-код.",
  foutPinFout: "Неверный пин-код.",
  foutProtocol: "Приложение и сервер не совместимы. Обнови страницу.",
  foutMicroGeweigerd: "Доступ к микрофону заблокирован. Нажми на замочек в адресной строке и разреши доступ.",
  foutGeenMicro: "Микрофон не найден. Подключи его и попробуй еще раз.",
  foutMicroInGebruik: "Микрофон используется другой программой. Закрой ее и попробуй снова.",
  foutGeenHttps: "Микрофон работает только при безопасном подключении. Открой страницу через https.",
  foutMicroOnbekend: "Не удалось запустить микрофон.",
  foutNietsOpgenomen: "Ничего не записано. Твой микрофон включен?",
  foutNietsGehoord: "Ничего не слышно. Твой микрофон включен и говоришь ли ты достаточно громко?",
  foutOpnameTeLang: "Запись слишком длинная. Говори более короткими фразами.",
  foutMicroGedempt: "Звук микрофона отключен. Включи его и попробуй снова.",

  // --- microfoontest ---
  micTitel: "Проверка микрофона",
  micOnderschrift: "Четыре теста подряд, по пять секунд каждый. Говори всё это время.",
  micStart: "Запустить тест",
  micTest1: "1. Только распознавание",
  micTest2: "2. Только запись",
  micTest3: "3. Вместе — сначала запись",
  micTest4: "4. Вместе — сначала распознавание",
  micFase1: "1 из 4: только распознавание — скажи короткую фразу",
  micFase2: "2 из 4: только запись — продолжай говорить",
  micFase3: "3 из 4: сначала запись, потом распознавание — продолжай говорить",
  micFase4: "4 из 4: сначала распознавание, потом запись — продолжай говорить",
  micKlaar: "готово",
  micGehoord: "услышано",
  micOpnameformaat: "Формат записи",
  micGeen: "нет",
  micBeveiligd: "Защищённое соединение",
  micJa: "да",
  micNee: "НЕТ",
  micBrowser: "Браузер",
  micGeenHttps: "Без https браузер не даст доступ к микрофону. На localhost можно.",
  micGeenHerkenning: "В этом браузере нет распознавания речи.",
  micZegIets: "скажи что-нибудь…",
  micWoordenBinnen: "слова приходят",
  micKonNietStarten: "не удалось запустить",
  micGeenRecorder: "Этот браузер не знает MediaRecorder.",
  micOpnemen: "идёт запись…",
  micNietsOpgenomen: "ничего не записано",
  micGeenMicrofoon: "нет микрофона",
  micOpnameEerst: "сначала запись…",
  micHerkenningEerst: "сначала распознавание…",
  micOpnameStarttNiet: "запись не началась",
  micSamenGelukt: "Вместе. Запись {kb} кБ.",
  micAlleenOpname: "Запись да, распознавание нет.",
  micAlleenHerkenning: "Распознавание да, запись нет.",
  micGeenVanBeide: "Ни то, ни другое.",
  micNetwerkFout: "Распознавание речи не смогло связаться с сервером.",
  micAfgebroken: "Запись была прервана.",
  verslagTitel: "Протокол разговора",
  verslagWie: "Кто",
  verslagOrigineel: "Оригинал",
  verslagVertaling: "Перевод",
  verslagSpreker: "Участник {x}",
  verslagBerichten: "Сообщения",
  verslagGemaaktOp: "Создан",
  verslagGeenOpname: "Это не дословная запись.",
  verslagNootOrigineel: "«Оригинал» — это текст в том виде, в каком приложение поняло говорящего.",
  verslagNootCorrectie: "Проверка орфографии была включена: мелкие опечатки исправлены.",
  verslagNootAangepast: "Говорящий мог изменить текст перед отправкой.",
  verslagGesproken: "устно",
  verslagGetypt: "набрано",
  verslagMislukt: "Перевод не удался. Собеседник не увидел эту фразу на своём языке.",
  verslagNietKlaar: "Перевод ещё не был готов, когда создавался этот протокол.",
  verslagVertrouwelijk: "Конфиденциально.",
  verslagAlleenDeelnemers: "Этот протокол содержит содержание частного разговора и предназначен только для его участников.",
  verslagGewist: "Дата удаления разговора: {tijd}. После этого протокол нельзя будет создать заново.",
  verslagGewistVast: "Постоянная комната: каждое сообщение удаляется через 30 дней после отправки. Более старых сообщений в этом протоколе нет.",
};
